import {User} from '../../../administration/models/user';

export class Preference {

  id: number;
  user: User;
  code: string;
  type: string;
  content: Content;
  logo: any;
  titre: string;
  dateCreation: Date;

  constructor() {
    this.content = new Content();
  }
}

export class Content {
  values: Value[];

  constructor() {
    this.values = [];
  }
}

export class Value {
  code: string;
  value: string;
}

